import url from 'url';

const parsedUrl = url.parse(window.location.href);
export const AUTH_CREDENTIALS = {
  domain: 'mediaferry.eu.auth0.com',
  clientId: 'D0rDp6YFEsd5iovKrfZ87y3E8Rv8nKYa',
  callbackUrl: `${parsedUrl.protocol}//${parsedUrl.host}/callback`,
  audience: 'https://mediaferry.eu.auth0.com/userinfo',
};
